<script>
  import { vendors, sortedVendors } from './stores/root.js'
  import { createVendor } from './stores/vendor.js'
  export let vendorId, disabled
  let newVendorName
  let saving = false
</script>

{#if vendorId === 'new'}
  <div class="row">
    <div class="col-10">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          name="vendor"
          placeholder="New Vendor"
          bind:value={newVendorName}
        />
      </div>
    </div>

    <div class="col-2">
      <button
        type="button"
        class="btn btn-primary"
        disabled={!newVendorName}
        on:click={async () => {
          const result = await createVendor(newVendorName)
          vendorId = result.id
          vendors.update((current) => [...current, result])
          saving = false
        }}
      >
        {#if saving}
          <div
            class="spinner-border spinner-border-sm text-light"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        {:else}
          Save
        {/if}
      </button>
    </div>
  </div>
{:else}
  <!-- svelte-ignore a11y-no-onchange -->
  <select
    name="vendor"
    id="vendor"
    class="form-select"
    {disabled}
    bind:value={vendorId}
  >
    <option value="" disabled selected>Select Vendor</option>
    {#each $sortedVendors as vendor}
      <option value={vendor.id}>{vendor.name}</option>
    {/each}
    <option value="" disabled>---------------</option>
    <option value="new">Add Vendor</option>
  </select>
{/if}
